import { FC, ReactNode } from 'react';
import { Collapse, Divider } from '@mui/material';
import { useCollapsibleCard } from './CollapsibleCardContext';

interface CollapsibleCardExpandAreaProps {
    children: ReactNode;
    divider?: boolean;
}

const CollapsibleCardExpandArea: FC<CollapsibleCardExpandAreaProps> = ({ children, divider = true }) => {
    const { expanded } = useCollapsibleCard();

    return (
        <Collapse in={expanded} timeout="auto" unmountOnExit>
            {divider && <Divider />}
            {children}
        </Collapse>
    );
};

export type { CollapsibleCardExpandAreaProps };
export default CollapsibleCardExpandArea;
